<script setup>
import { useQuasar } from 'quasar';
const $q = useQuasar();
defineProps(['error'])
</script>


<template>
    <div class="row justify-center items-center q-pa-md" style="height: 100vh;">
        <div class="col-12 col-md-6">
            <div class="text-center">
                <div :style="{ border: '4px solid black', padding: '10px', maxWidth: $q.screen.lt.sm ? '50%' : '40%', margin: '0 auto' }">
                    <p class="q-mb-none blurry-text" :style="{ fontSize: $q.screen.lt.md ? '2.5em' : '5em' }">E</p>
                    <p class="q-mb-none blurry-text" :style="{ fontSize: $q.screen.lt.md ? '2.25em' : '4.5em' }">F P</p>
                    <p class="q-mb-none blurry-text" :style="{ fontSize: $q.screen.lt.md ? '2em' : '4em' }">4 0 4</p>
                    <p class="q-mb-none blurry-text" :style="{ fontSize: $q.screen.lt.md ? '1.75em' : '3.5em' }">L P E D</p>
                    <p class="q-mb-none blurry-text" :style="{ fontSize: $q.screen.lt.md ? '1.5em' : '3em' }">P E C F D</p>
                    <p class="q-mb-none blurry-text" :style="{ fontSize: $q.screen.lt.md ? '1.25em' : '2.5em' }">E D F C Z P</p>
                </div>
                <br>



               
                <p class="q-mb-none" :style="{ fontSize: $q.screen.lt.md ? '1.5em' : '3em' }">Oops! Something went
                    wrong.</p>
                <!-- <p class="q-mb-none" :style="{ fontSize: $q.screen.lt.md ? '1.5em' : '3em' }">{{ error.message }}</p> -->
                <!-- <p v-if="error.message && error.message.includes('Page not found:')" class="q-mb-none" :style="{ fontSize: $q.screen.lt.md ? '1.5em' : '3em' }">{{ error.message }}</p> -->
                <br>
                <q-btn no-caps flat unelevated class="bg-brand text-white" :size="$q.screen.lt.md ? '1.5em' : '1.75em'"
                    to="/" label="Go Back Home" />
            </div>
        </div>
    </div>
</template>

<style scoped>
.blurry-text {
    filter: blur(2px);
}
</style>